<div id="fiche">
  <div class="fiche">
    <div class="blocproduit">
      <div class="titre">
        <h1>{{ produit.nomProduit }}</h1>
      </div>
      <div class="destination">
        <mat-icon class="loc" *ngIf="produit.destination">location_pin</mat-icon>
        <span *ngIf="produit.parent">
          <a [href]="'/d/' + produit.parent"> {{ produit.parent }} </a>,
        </span>
        <a [href]="'/d/' + produit.destination">
          {{ produit.destination }}
        </a>
      </div>
      <div class="contenu">
        <div class="img">
          <img class="imgproduit mat-elevation-z10" [src]="produit.image" />
        </div>
        <div class="infoproduit">
          <div class="blocInfo">
            <div class="promotion" *ngIf="produit.promotion">
              {{ produit.promotion }}
            </div>
            <div class="cat">{{ produit.nameCategorie }}</div>
            <mat-chip *ngFor="let tag of produit.tags">
              <a [href]="getLink(produit.destination, produit.categorie, tag)">{{ tag }}</a>
            </mat-chip>
            <div class="prix" *ngIf="produit.prix">{{ produit.prix }}</div>
            <div class="description" [innerHTML]="produit.description"></div>
          </div>
          <div class="vendeur">
            <div class="logo">
              Proposé par :
              <img [src]="urlLogo + '/' + produit.marchand.logo" />
            </div>
            <div class="urlVendeur">
              <a [href]="produit.urlProduit" target="_blank">
                <button mat-raised-button (click)="clickStatistique()">
                  Découvrir
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="related" *ngIf="related.length>0">
      <div class="related">
        <h3>Vous pourriez aussi aimer ...</h3>
      </div>
      <div class="wrapper">
        <div class="wrapcenter">
          <div class="box">
            <div *ngFor="let relate of related">
              <cardProduit [produit]="relate"></cardProduit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>